var _polygon, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgImmobilisations = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.39 51.54",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: ".12 10.63 17.76 .18 35.57 13.24 25.84 32.67 4.63 32.52 .12 10.63",
    fill: "#ff7bae",
    opacity: 0.2,
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.23,1.33v18.92l-14.27,11.17v19.99h41.23v-31.19L33.23,1.33ZM33.23,49.85h-12.7v-17.66l12.7-9.94v27.61ZM58.63,49.85h-23.83V4.34l23.83,16.7v28.81Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.54,51.76H18.62v-20.51l14.27-11.17V.67l27.66,19.38v31.72ZM19.31,51.07h40.54v-30.66L33.58,2v18.42l-14.27,11.17v19.47ZM58.98,50.2h-24.53V3.68l24.53,17.19v29.33ZM35.15,49.5h23.14v-28.28L35.15,5.01v44.49ZM33.58,50.2h-13.4v-18.18l13.4-10.49v28.67ZM20.88,49.5h12.01v-26.55l-12.01,9.4v17.14Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.35,
    y: 22.93,
    width: 4.2,
    height: 2.99,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9,26.27h-4.9v-3.69h4.9v3.69ZM41.69,25.57h3.51v-2.3h-3.51v2.3Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46.7,
    y: 22.93,
    width: 4.2,
    height: 2.99,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.25,26.27h-4.9v-3.69h4.9v3.69ZM47.05,25.57h3.51v-2.3h-3.51v2.3Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.35,
    y: 27.13,
    width: 4.2,
    height: 2.99,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9,30.47h-4.9v-3.69h4.9v3.69ZM41.69,29.77h3.51v-2.3h-3.51v2.3Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46.7,
    y: 27.13,
    width: 4.2,
    height: 2.99,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.25,30.47h-4.9v-3.69h4.9v3.69ZM47.05,29.77h3.51v-2.3h-3.51v2.3Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.35,
    y: 31.33,
    width: 4.2,
    height: 2.99,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9,34.67h-4.9v-3.69h4.9v3.69ZM41.69,33.98h3.51v-2.3h-3.51v2.3Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46.7,
    y: 31.33,
    width: 4.2,
    height: 2.99,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.25,34.67h-4.9v-3.69h4.9v3.69ZM47.05,33.98h3.51v-2.3h-3.51v2.3Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.35,
    y: 35.53,
    width: 4.2,
    height: 2.99,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9,38.87h-4.9v-3.69h4.9v3.69ZM41.69,38.18h3.51v-2.3h-3.51v2.3Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46.7,
    y: 35.53,
    width: 4.2,
    height: 2.99,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.25,38.87h-4.9v-3.69h4.9v3.69ZM47.05,38.18h3.51v-2.3h-3.51v2.3Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.35,
    y: 39.73,
    width: 4.2,
    height: 2.99,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9,43.07h-4.9v-3.69h4.9v3.69ZM41.69,42.38h3.51v-2.3h-3.51v2.3Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46.7,
    y: 39.73,
    width: 4.2,
    height: 2.99,
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.25,43.07h-4.9v-3.69h4.9v3.69ZM47.05,42.38h3.51v-2.3h-3.51v2.3Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImmobilisations);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/immobilisations.58e51d05373216f05f74b679acf5c92e.svg";